/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { searchCloudWatchSearchPost } from '../fn/search/search-cloud-watch-search-post';
import { SearchCloudWatchSearchPost$Params } from '../fn/search/search-cloud-watch-search-post';
import { searchFileContentPost } from '../fn/search/search-file-content-post';
import { SearchFileContentPost$Params } from '../fn/search/search-file-content-post';
import { searchGet } from '../fn/search/search-get';
import { SearchGet$Params } from '../fn/search/search-get';
import { searchListBucketsGet } from '../fn/search/search-list-buckets-get';
import { SearchListBucketsGet$Params } from '../fn/search/search-list-buckets-get';
import { searchLogGroupsGet } from '../fn/search/search-log-groups-get';
import { SearchLogGroupsGet$Params } from '../fn/search/search-log-groups-get';
import { searchSearchPost } from '../fn/search/search-search-post';
import { SearchSearchPost$Params } from '../fn/search/search-search-post';

@Injectable({ providedIn: 'root' })
export class SearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchGet()` */
  static readonly SearchGetPath = '/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet$Response(params?: SearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet(params?: SearchGet$Params, context?: HttpContext): Observable<void> {
    return this.searchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchListBucketsGet()` */
  static readonly SearchListBucketsGetPath = '/Search/list-buckets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchListBucketsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchListBucketsGet$Response(params?: SearchListBucketsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchListBucketsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchListBucketsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchListBucketsGet(params?: SearchListBucketsGet$Params, context?: HttpContext): Observable<void> {
    return this.searchListBucketsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchSearchPost()` */
  static readonly SearchSearchPostPath = '/Search/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchSearchPost$Response(params?: SearchSearchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchSearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchSearchPost(params?: SearchSearchPost$Params, context?: HttpContext): Observable<void> {
    return this.searchSearchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchCloudWatchSearchPost()` */
  static readonly SearchCloudWatchSearchPostPath = '/Search/cloud-watch-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCloudWatchSearchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchCloudWatchSearchPost$Response(params?: SearchCloudWatchSearchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchCloudWatchSearchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCloudWatchSearchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchCloudWatchSearchPost(params?: SearchCloudWatchSearchPost$Params, context?: HttpContext): Observable<void> {
    return this.searchCloudWatchSearchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchLogGroupsGet()` */
  static readonly SearchLogGroupsGetPath = '/Search/log-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchLogGroupsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchLogGroupsGet$Response(params?: SearchLogGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchLogGroupsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchLogGroupsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchLogGroupsGet(params?: SearchLogGroupsGet$Params, context?: HttpContext): Observable<void> {
    return this.searchLogGroupsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchFileContentPost()` */
  static readonly SearchFileContentPostPath = '/Search/file-content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchFileContentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchFileContentPost$Response(params?: SearchFileContentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return searchFileContentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchFileContentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  searchFileContentPost(params?: SearchFileContentPost$Params, context?: HttpContext): Observable<void> {
    return this.searchFileContentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
